module.exports = __webpack_public_path__ + "img/qrcode-bgc.1b8523ca.png";